<template>
  <GetStartedInstructions
    :class="$style.collapsableSection"
    :localStorageKey="localStorageKey"
    primaryLink="https://support.jumpcloud.com/support/s/article/getting-started-groups"
    :startCollapsed="collapsed"
    title=""
  >
    <GroupsGetStartedInfo />
  </GetStartedInstructions>
</template>

<script>
import { LocalStorageConsts } from 'client/util/Constants';
import GetStartedInstructions from 'components/GetStartedInstructions/GetStartedInstructions.vue';
import GroupsGetStartedInfo from 'client/groups/GroupsGetStartedInfo.vue';

const { groupsInstructionsDismissed } = LocalStorageConsts;

export default {
  name: 'GroupsGetStartedInstructions',
  components: {
    GetStartedInstructions,
    GroupsGetStartedInfo,
  },

  data: () => ({
    collapsed: false,
    localStorageKey: groupsInstructionsDismissed,
  }),
};
</script>

<style module>
.collapsableSection {
  margin-bottom: 0;
}

/* If we don't use this selector, we have to pass a prop to GetStartedInstructions.vue
who then will have to pass a prop to CollapsableSection.vue */
</style>
